<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link><span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <router-link class="decoration" to="/tinternalcourses/scheduled">Scheduled Internal Courses</router-link><span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        {{ schedule.schedule_code || 'Scheduled Course' }}
      </h6>
      <div class="container-fluid">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <button type="button" class="btn btn-sm btn-outline-primary mb-1 bdr-rad font-size_def" @click="goToScheduledCourses">Back to Scheduled Courses</button>
          <button type="button" class="btn btn-sm btn-outline-primary mb-1 bdr-rad font-size_def" @click="showMessage('Attendance Sheet')">Upload Attendance Record</button>
          <button type="button" class="btn btn-sm btn-outline-primary mb-1 bdr-rad font-size_def" @click="showMessage('Update')">Update</button>
        </div>
        <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
        <div v-if="message" class="alert alert-info">{{ message }}</div>
        <div v-if="isLoading" class="card custom_bdr_rds shadow p-2"><div class="card-body custom_bdr_rds"><div class="d-flex justify-content-center"><div class="spinner-border text-primary"></div></div></div></div>
        <div v-else class="mt-1">
          <div class="card custom_bdr_rds shadow p-2">
            <div class="card-body custom_bdr_rds">
              <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                <tbody>
                  <tr><td class="width-custom2"><b>Course</b></td><td>{{ schedule.course_title }}</td></tr>
                  <tr><td><b>Module</b></td><td>{{ schedule.module_name }}</td></tr>
                  <tr><td><b>Class Code</b></td><td>{{ schedule.schedule_code }}</td></tr>
                  <tr><td><b>Course Code</b></td><td>{{ schedule.course_code }}</td></tr>
                  <tr><td><b>Available Slots</b></td><td>{{ schedule.available_slots }}</td></tr>
                  <tr><td><b>Allocated Slots</b></td><td>{{ schedule.allocated_slots }}</td></tr>
                  <tr><td><b>Remain Slots</b></td><td>{{ schedule.remain_slots }}</td></tr>
                  <tr><td><b>Class Date</b></td><td>{{ formatDate(schedule.class_date) }}</td></tr>
                  <tr><td><b>Day</b></td><td>{{ schedule.day }}</td></tr>
                  <tr><td><b>Start Time</b></td><td>{{ schedule.start_time || '-' }}</td></tr>
                  <tr><td><b>End Time</b></td><td>{{ schedule.end_time || '-' }}</td></tr>
                  <tr><td><b>Trainer</b></td><td>{{ schedule.trainer || '-' }}</td></tr>
                  <tr><td><b>Status</b></td><td>{{ schedule.status_name }}</td></tr>
                  <tr><td><b>Created Date</b></td><td>{{ schedule.created_date || '-' }}</td></tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card custom_bdr_rds shadow p-2">
            <div class="card-body custom_bdr_rds">
              <h6 class="purchitem mb-2"><b class="small">Attendance Record</b></h6>
              <table style="font-size: small;" class="table table-hover table-sm table-borderless mb-0"><tbody>
                <tr><td class="width-custom2"><b>Attendance File</b></td><td>{{ schedule.attendance_file || '-' }}</td></tr>
                <tr><td><b>Upload By</b></td><td>{{ schedule.attendance_uploaded_by || '-' }}</td></tr>
              </tbody></table>
            </div>
          </div>
          <div class="card custom_bdr_rds shadow p-2">
            <div class="card-body custom_bdr_rds">
              <h6 class="purchitem mb-2"><b class="small">Scheduled Attendees for Class</b></h6>
              <div class="d-flex justify-content-end mb-2">
                <button type="button" class="btn btn-sm btn-outline-primary bdr-rad mr-2 font-size_def" @click="setAllAttendees('Present')">Present All</button>
                <button type="button" class="btn btn-sm btn-outline-primary bdr-rad font-size_def" @click="setAllAttendees('Absent')">Absent All</button>
              </div>
              <div class="table-responsive">
                <table style="font-size: small;" class="table table-hover table-sm table-borderless mb-0">
                  <thead class="background_color2"><tr class="custom-label2"><th><input type="checkbox" v-model="allAttendeesSelected"></th><th>Employee</th><th>Employee Name</th><th>Class Name</th><th>From Date</th><th>To Date</th><th>Status</th><th>Written Result</th><th>Practical Result</th><th>Total Result</th></tr></thead>
                  <tbody><tr v-for="attendee in attendees" :key="attendee.id"><td><input type="checkbox" v-model="attendee.selected"></td><td>{{ attendee.employee }}</td><td>{{ attendee.employee_name }}</td><td>{{ attendee.class_name }}</td><td>{{ attendee.from_date }}</td><td>{{ attendee.to_date }}</td><td>{{ attendee.status }}</td><td>{{ attendee.written_result }}</td><td>{{ attendee.practical_result }}</td><td>{{ attendee.total_result }}</td></tr><tr v-if="!attendees.length"><td colspan="10" class="text-muted">No results found.</td></tr></tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
    
      </div>
          <br><br>
    </div>
           
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: { TopNavbar, ContentFooter },
  data() { return { token: authService.isLoggedIn(), isLoading: true, errorMessage: '', message: '', schedule: {}, attendees: [], allAttendeesSelected: false }; },
  mounted() { this.loadSchedule(); },
  methods: {
    async loadSchedule() { try { const { data } = await axios.get('/ticourses/schedule-view?id=' + this.$route.query.id, { headers: { Authorization: 'Bearer ' + this.token } }); this.schedule = data.schedule || {}; } catch (error) { this.errorMessage = (error.response && error.response.data && (error.response.data.message || error.response.data.name)) || 'Unable to load scheduled course.'; } finally { this.isLoading = false; } },
    formatDate(value) { if (!value) return '-'; const date = new Date(value + 'T00:00:00'); return [String(date.getDate()).padStart(2, '0'), String(date.getMonth() + 1).padStart(2, '0'), date.getFullYear()].join('-'); },
    showMessage(value) { this.message = value + ' function is not connected yet.'; },
    goToScheduledCourses() { this.$router.push('/tinternalcourses/scheduled'); },
    setAllAttendees(status) { this.attendees.forEach((attendee) => { if (!this.allAttendeesSelected || attendee.selected) attendee.status = status; }); this.message = status + ' status applied to selected attendees.'; },
  },
};
</script>
